import { MouseEvent } from 'react';

import { K5CardImage } from 'src/components/elementary-school-view/k5-card-image';
import { useCommonXapiContextPayloadHook } from 'src/hooks/use-common-xapi-context-payload.hook';
import { XApiEventKeys } from 'src/interfaces/event.types';
import { MSProduct } from 'src/interfaces/ms-product.types';
import { Theme } from 'src/interfaces/theme.types';
import eventService from 'src/services/event.service';

import './elementary-school-apps-card.scss';

type ElementarySchoolAppsCardProps = {
  theme: Theme;
  product: MSProduct;
};

export const ElementarySchoolAppsCard = ({
  theme,
  product,
}: ElementarySchoolAppsCardProps) => {
  const commonXapiContextPayload = useCommonXapiContextPayloadHook();

  const cardImageClassnames = {
    imageClassnames: product.imageClassNames,
  };

  const handleAppsCardClick = async (e: MouseEvent) => {
    e.preventDefault();

    try {
      await eventService.send(
        XApiEventKeys.selectedAppsCard,
        {
          result: {
            destinationUrl: product.url,
          },
        },
        {
          result: {
            isRightClick: e.type === 'contextmenu',
            productId: product.id,
            appCardName: product.domainMsView ?? product.domain,
            ...commonXapiContextPayload,
          },
        },
      );
    } catch (error) {
      console.error('Error sending opened assignment event', error);
    } finally {
      if (e.type !== 'contextmenu') {
        window.location.assign(product.url);
      }
    }
  };

  return (
    <a
      className="elementary-school-apps-card"
      href={product.url}
      onClick={handleAppsCardClick}
      onContextMenu={handleAppsCardClick}
    >
      <K5CardImage
        theme={theme}
        imagePath={product.imageUrl}
        shouldConstructImagePath={false}
        classNames={cardImageClassnames}
      />
      <h3 className="elementary-school-apps-card__label">{product.domain}</h3>
    </a>
  );
};
